import { EventLoggingParams, LogEvent, LogEventKey } from "src/app/interfaces/log";
import { LogService } from 'src/app/services/log/log.service';

export class SignalLogService {
  constructor(private logService: LogService) {
    
  }

  homeSignalImpression(): void {
    this.eventLogging(LogEvent.HOME_SIGNAL_IMPRESSION);
  } 

  signalMainViewed(receivedSignalNumber: number): void {
    this.eventLogging(LogEvent.SIGNAL_MAIN_VIEWED, { receivedSignalNumber });
  }
  signalSubmit(): void {
    this.eventLogging(LogEvent.SIGNAL_SUBMIT);
  }
  signalSendResultViewed(): void {
    this.eventLogging(LogEvent.SIGNAL_SEND_RESULT_VIEWED);
  }
  signalNumberEntryViewed(): void {
    this.eventLogging(LogEvent.SIGNAL_NUMBER_ENTRY_VIEWED);
  }
  signalNumberEntryKeyboardOpened(): void {
    this.eventLogging(LogEvent.SIGNAL_NUMBER_ENTRY_KEYBOARD_OPENED);
  }
  signalIntoViewed(): void {
    this.eventLogging(LogEvent.SIGNAL_INTRO_VIEWED);
  }
  signalSendExampleModalViewed(): void {
    this.eventLogging(LogEvent.SIGNAL_SEND_EXAMPLE_MODAL_VIEWED);
  }
  signalRevealMyselfAgreed(): void {
    this.eventLogging(LogEvent.SIGNAL_REVEAL_MYSELF_AGREED);
  }
  signalRevealMySelfDisagreed(): void {
    this.eventLogging(LogEvent.SIGNAL_REVEAL_MYSELF_DISAGREED);
  }
  signalShareClicked(): void {
    this.eventLogging(LogEvent.SIGNAL_SHARE_CLICKED);
  }
  signalKakaoNumberAgreementRequiredViewed(): void {
    this.eventLogging(LogEvent.SIGNAL_KAKAO_NUMBER_AGREEMENT_REQUIRE_VIEWED);
  }
  signalKakaoNumberNotFoundViewed(): void {
    this.eventLogging(LogEvent.SIGNAL_KAKAO_NUMBER_NOT_FOUND_VIEWED);
  }
  homeSignalClicked(): void {
    this.eventLogging(LogEvent.HOME_SIGNAL_CLICKED);
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, { ...params });
  }
}